import React, { useState, useMemo, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';

import MuiGrid from '@material-ui/core/Grid';
import MuiButton from '@material-ui/core/Button';
import { Add as AddIcon, Search as SearchIcon } from '@material-ui/icons';

import { Box, TextField, InputAdornment } from '@material-ui/core';

import debounce from 'lodash/debounce';

import ViewWrapper from 'views/ViewWrapper';
import TableGroups from './list-groups-table';
import DialogCreateGroup from 'components/DialogCreateGroup';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  select: {
    minWidth: '100px',
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  formRow: {
    display: 'flex',
  },
});

const Groups = ({ ...props }) => {
  const { id } = useParams();
  const { classes } = props;

  const [isGroupDialogOpen, setIsGroupDialogOpen] = useState(false);
  //selectedSearch is added after the debounced.
  const [selectedSearchTerm, setSelectedSearchTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const handleGroupCreated = data => {
    if (data.is_label_account) {
      alert(
        `
        * An invoice was generated for '${data.email}'.
        * It will be automatically sent in 1 hour.
        * You may review and update the invoice in the Stripe dashboard until then.
        * The group will be created once payment is complete.`
      );
    } else {
      setSearchTerm(data.name);
      setSelectedSearchTerm(data.name);
    }

    setIsGroupDialogOpen(false);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce(value => {
        if (value && value.length < 3) return; // no reason to search if it is less than 3, however if it is null refetch without query
        setSelectedSearchTerm(value);
      }, 500),
    []
  );

  const handleSearch = ({ target: { value } }) => {
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleDialogOpen = () => setIsGroupDialogOpen(true);
  const handleDialogClose = () => setIsGroupDialogOpen(false);

  useEffect(() => {
    const email = new URLSearchParams(window.location.search).get('email');
    if (email) {
      debouncedSearch(email);
    }
  }, []);

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Groups
          </MuiTypography>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            <TextField
              variant="outlined"
              label="Search"
              placeholder="User or Group name or email"
              style={{ minWidth: '350px' }}
              value={searchTerm}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <MuiButton
              variant="contained"
              size="small"
              className={classes.actionButton}
              startIcon={<AddIcon />}
              onClick={handleDialogOpen}>
              Add Group
            </MuiButton>
          </Box>
          <TableGroups selectedSearchTerm={selectedSearchTerm} selectedGroupId={id} />
        </MuiPaper>
      </MuiGrid>
      <DialogCreateGroup open={isGroupDialogOpen} onClose={handleDialogClose} onCreated={handleGroupCreated} />
    </ViewWrapper>
  );
};

export default withStyles(styles)(Groups);
